import React, { memo, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Tooltip from '../../../tooltip';
import Button, { ButtonTypes } from '../../../button';
import { PRIMARY_BUTTON_CLASS } from '../../constants';

const ButtonWrapper = ({
  id, label, renderIcon, type, borderLess, onClick, className, description, disabled, loading,
  testIds,
}) => {
  const classes = clsx(className, { [PRIMARY_BUTTON_CLASS]: type === ButtonTypes.PRIMARY });
  const onClickCallback = useCallback(() => onClick(id), [id, onClick]);

  const getButton = () => (
    <Button
      id={id}
      key={id}
      type={type}
      renderIcon={renderIcon}
      label={label}
      disabled={disabled}
      className={classes}
      borderLess={borderLess}
      onClick={onClickCallback}
      loading={loading}
      testIds={testIds}
    />
  );

  return description ? <Tooltip description={description}>{getButton()}</Tooltip> : getButton();
};

ButtonWrapper.defaultProps = {
  id: '',
  label: '',
  renderIcon: null,
  className: '',
  disabled: false,
  description: '',
  borderLess: false,
  onClick: () => {},
  type: ButtonTypes.PRIMARY,
  loading: false,
  testIds: {},
};

ButtonWrapper.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  borderLess: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.string,
  renderIcon: PropTypes.func,
  type: PropTypes.oneOf(Object.values(ButtonTypes)),
  loading: PropTypes.bool,
  testIds: PropTypes.shape({}),
};

export default memo(ButtonWrapper);
